import { Disclaimer } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";

export const MetricsDisclaimer: React.FC = () => {
  const [t] = useTranslation("metrics");

  const { show, handleClose } = Disclaimer.useShowState({
    localStorageKey: "showDisclaimerMetrics",
  });

  return (
    <Disclaimer.Card show={show}>
      <Disclaimer.Text>{t("disclaimer.text")}</Disclaimer.Text>
      <Disclaimer.Button onPress={handleClose}>
        {t("disclaimer.close")}
      </Disclaimer.Button>
    </Disclaimer.Card>
  );
};
